import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  get(id) {
    return BackendAPI('get', ApiRoutes.videoViewingPole.get(id));
  },
  upgradeLevel(id, data = {}) {
    return BackendAPI('put', ApiRoutes.videoViewingPole.upgradeLevel(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.videoViewingPole.changePassword(id), passData);
  },
};
